<template>
  <div id="app">
    <h-loading :options='options'></h-loading>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
      }
    },
    methods: {
      handleLogin() {
        // this.$hloading.show(); // loading显示 --- 回调开始  Loading 显示
        // if(this.isClick == false){
        //     return;
        // }
        // this.isClick = false;  // 防多点击
        // let data = {
        //     userName: this.loginForm.userName, // 帐号
        //     passWord: this.loginForm.passWord, // 密码
        //     device: this.loginForm.device, // 设备端
        //     parentGame: this.loginForm.parentGame, // 父级
        //     childGame: this.loginForm.childGame // 子级
        // }
        // this.$store.dispatch('LoginByToken', data).then((res) => {
        //     this.$tips.success('登录成功') // 成功提示
        //     this.$loading.hidden(); // loading隐藏 --------回调成功后 Loading隐藏
        //     this.isClick = true;  // 防多点击
        //     if(res.data.code == 0){
        //         setToken(res.data.token)
        //         this.$router.push({ path: this.redirect || '/' })
        //     }
        // })
      }
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue